import {Injectable} from '@angular/core';
import {HttpService} from '../services/http-service';
import {Observable} from 'rxjs';

@Injectable()
export class HarmonogramService {
    constructor (private httpService: HttpService) {

    }

    list(): Observable<any[]> {
        return this.httpService.get('/api/harmonogram/list');
    }

    get(id: string): Observable<any> {
        return this.httpService.get('/api/harmonogram/get', {
            id: id
        });
    }

    lastExchangeRate(masterCurrencyId: number, slaveCurrencyId: number): Observable<any> {
        return this.httpService.get('/api/currency/last-exchange-rate', {
            masterCurrencyId: masterCurrencyId,
            slaveCurrencyId: slaveCurrencyId
        });
    }

    edit(item: any): Observable<boolean> {
        return this.httpService.post('/api/harmonogram/edit', item);
    }

    create(item: any): Observable<boolean> {
        return this.httpService.post('/api/harmonogram/create', item);
    }

    changeStatus(harmonogramId: number, status: number): Observable<boolean> {
        return this.httpService.post('/api/harmonogram/change-status', {
            harmonogramId: harmonogramId,
            status: status
        });
    }

    delete(harmonogramId: number): Observable<boolean> {
        return this.httpService.post('/api/harmonogram/delete', {
            harmonogramId: harmonogramId
        });
    }
}
